import { API } from "../api";
import axios from "axios";
const jsonHeaders = { "Content-Type": "application/json" };

export const registerCar = async (payload) => {
  try {
    const { data } = await axios.post(`${API.DEV}/car/create`, payload, {
      headers: jsonHeaders,
    });
    return data;
  } catch (err) {
    console.log(err);
    if (err.response.data) return err.response.data;
    throw new Error(err);
  }
};

export const deleteCar = async (id) => {
  try {
    const { data } = await axios.get(`${API.DEV}/car/delete/${id}`);
    return data;
  } catch (err) {
    throw new Error(err);
  }
};

export const updateCar = async (payload, id) => {
  try {
    const { data } = await axios.post(`${API.DEV}/car/update/${id}`, payload, {
      headers: jsonHeaders,
    });
    return data;
  } catch (err) {
    throw new Error(err);
  }
};

export const findCar = async (payload) => {
  try {
    const { data } = await axios.post(`${API.DEV}/car/findone`, payload, {
      headers: jsonHeaders,
    });
    return data;
  } catch (err) {
    return null;
  }
};

export const findAllCars = async () => {
  try {
    const { data } = await axios.get(`${API.DEV}/car/list/`);
    return data;
  } catch (err) {
    throw new Error(err);
  }
};

export const getBrandMetrics = async () => {
  try {
    const { data } = await axios.get(`${API.DEV}/car/metrics/brands`);
    return data;
  } catch (err) {
    console.log(err);
    return [];
  }
};

export const getDocs = async () => {
  try {
    const { data } = await axios.get(`${API.DEV}/car/list/`);

    let month = filterByCurrentMonth(data);

    return {
      monthly: month.length,
      total: data.length,
    };
  } catch (err) {
    throw new Error(err);
  }
};

function filterByCurrentMonth(data) {
  const now = new Date();
  const currentMonth = now.getMonth();
  const currentYear = now.getFullYear();

  return data.filter((item) => {
    const itemDate = new Date(item.date);
    return (
      itemDate.getMonth() === currentMonth &&
      itemDate.getFullYear() === currentYear
    );
  });
}

export const findById = async (id) => {
  try {
    const { data } = await axios.get(`${API.DEV}/car/findbyid/${id}`);
    return data;
  } catch (err) {
    throw new Error(err);
  }
};